import React, { FC } from "react";
import ArticleMeta from "legal/components/ArticleMeta/ArticleMeta";
import { Headline, Paragraph } from "legal/components/typography";
import { SCREEN_NAME, ScreenViewReporter } from "legal/imports/analytics";
import { FormattedMessageTitle } from "legal/imports/components";
import { legalMessages } from "legal/imports/constants";
import styles from "legal/common/LegalArticle.scss";

/* eslint-disable react/jsx-no-literals */
const ThirdPartyLicense: FC = () => (
  <>
    <ScreenViewReporter name={SCREEN_NAME.LEGAL_THIRD_PARTY_LICENSE} />
    <FormattedMessageTitle {...legalMessages.thirdPartyLicense} />

    <article className={styles.article}>
      <ArticleMeta postDate="Last Modified: 06.07.2014" withLanguagePicker />

      <Headline level={1}>
        Software used by Tango Mobile Application and relevant license info:
      </Headline>
      <Paragraph>
        Expat
        <br /> —– <br />
        Copyright (c) 1998, 1999, 2000 Thai Open Source Software Center Ltd
        Permission is hereby granted, free of charge, to any person obtaining a
        copy of this software and associated documentation files (the
        “Software”), to deal in the Software without restriction, including
        without limitation the rights to use, copy, modify, merge, publish,
        distribute, sublicense, and/or sell copies of the Software, and to
        permit persons to whom the Software is furnished to do so, subject to
        the following conditions: <br />
        The above copyright notice and this permission notice shall be included
        in all copies or substantial portions of the Software. <br />
        THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS
        OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
        IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
        CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
        TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
        SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. <br />
      </Paragraph>
      <Paragraph>
        OpenSSL <br />
        —– <br />
        Copyright (c) 1998-2011 The OpenSSL Project. All rights reserved.
        Redistribution and use in source and binary forms, with or without
        modification, are permitted provided that the following conditions are
        met: 1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer. 2.
        Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution. 3.
        All advertising materials mentioning features or use of this software
        must display the following acknowledgment: “This product includes
        software developed by the OpenSSL Project for use in the OpenSSL
        Toolkit. (http://www.openssl.org/)” 4. The names “OpenSSL Toolkit” and
        “OpenSSL Project” must not be used to endorse or promote products
        derived from this software without prior written permission. For written
        permission, please contact openssl-core@openssl.org. 5. Products derived
        from this software may not be called “OpenSSL” nor may “OpenSSL” appear
        in their names without prior written permission of the OpenSSL Project.
        6. Redistributions of any form whatsoever must retain the following
        acknowledgment: “This product includes software developed by the OpenSSL
        Project for use in the OpenSSL Toolkit (http://www.openssl.org/)” THIS
        SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT “AS IS” AND ANY EXPRESSED OR
        IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
        WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
        DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR ITS CONTRIBUTORS BE
        LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
        CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
        SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
        INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
        CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
        ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF
        THE POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        ====================================================================
        <br />
        This product includes cryptographic software written by Eric Young
        (eay@cryptsoft.com). This product includes software written by Tim
        Hudson (tjh@cryptsoft.com). <br />
        ————— <br />
        Copyright 2008, Google Inc. All rights reserved. <br />
      </Paragraph>
      <Paragraph>
        Redistribution and use in source and binary forms, with or without
        modification, are permitted provided that the following conditions are
        met: * Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer. *
        Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution. *
        Neither the name of Google Inc. nor the names of its contributors may be
        used to endorse or promote products derived from this software without
        specific prior written permission. THIS SOFTWARE IS PROVIDED BY THE
        COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED
        WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
        MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
        NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
        DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
        DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
        OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
        HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
        STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
        ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGE. Code generated by the Protocol Buffer
        compiler is owned by the owner of the input file used when generating
        it. This code is not standalone and requires a support library to be
        linked with it. This support library is itself covered by the above
        license.
      </Paragraph>
      <Paragraph>
        Zlib <br />
        —- <br />
        Copyright (C) 1995-2010 Jean-loup Gailly and Mark Adler This software is
        provided ‘as-is’, without any express or implied warranty. In no event
        will the authors be held liable for any damages arising from the use of
        this software. Permission is granted to anyone to use this software for
        any purpose, including commercial applications, and to alter it and
        redistribute it freely, subject to the following restrictions: 1. The
        origin of this software must not be misrepresented; you must not claim
        that you wrote the original software. If you use this software in a
        product, an acknowledgment in the product documentation would be
        appreciated but is not required. 2. Altered source versions must be
        plainly marked as such, and must not be misrepresented as being the
        original software. 3. This notice may not be removed or altered from any
        source distribution.
      </Paragraph>
      <Paragraph>
        Jean-loup Gailly <br />
        Mark Adler <br />
        Speex <br />
        —- <br />
        Â© 2002-2003, Jean-Marc Valin/Xiph.Org Foundation Redistribution and
        use in source and binary forms, with or without modification, are
        permitted provided that the following conditions are met:
        Redistributions of source code must retain the above copyright notice,
        this list of conditions and the following disclaimer. Redistributions in
        binary form must reproduce the above copyright notice, this list of
        conditions and the following disclaimer in the documentation and/or
        other materials provided with the distribution. Neither the name of the
        Xiph.org Foundation nor the names of its contributors may be used to
        endorse or promote products derived from this software without specific
        prior written permission.
        <br />
        THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
        -YÂ´AS ISÂ¡ AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT-A
        LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
        PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE FOUNDATION OR
        CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
        PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
        LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        Google Webrtc <br />
        —- <br />
        Copyright (c) 2011, Google Inc. All rights reserved. Redistribution and
        use in source and binary forms, with or without modification, are
        permitted provided that the following conditions are met: *
        Redistributions of source code must retain the above copyright notice,
        this list of conditions and the following disclaimer. * Redistributions
        in binary form must reproduce the above copyright notice, this list of
        conditions and the following disclaimer in the documentation and/or
        other materials provided with the distribution. * Neither the name of
        Google nor the names of its contributors may be used to endorse or
        promote products derived from this software without specific prior
        written permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS
        AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES,
        INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
        THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
        INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
        NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
        USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
        ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
        (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
        THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        Cisco libsrtp <br />
        —- <br />
        Copyright (c) 2001-2005 Cisco Systems, Inc. All rights reserved.
        Redistribution and use in source and binary forms, with or without
        modification, are permitted provided that the following conditions are
        met: Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.
        Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.
        Neither the name of the Cisco Systems, Inc. nor the names of its
        contributors may be used to endorse or promote products derived from
        this software without specific prior written permission. THIS SOFTWARE
        IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY
        EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
        PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS OR
        CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
        PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
        LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        Google libjingle <br />
        —————- <br />
        Copyright 2004–2007, Google Inc. Redistribution and use in source and
        binary forms, with or without modification, are permitted provided that
        the following conditions are met: Redistributions of source code must
        retain the above copyright notice, this list of conditions and the
        following disclaimer. Redistributions in binary form must reproduce the
        above copyright notice, this list of conditions and the following
        disclaimer in the documentation and/or other materials provided with the
        distribution. The name of the author may not be used to endorse or
        promote products derived from this software without specific prior
        written permission. THIS SOFTWARE IS PROVIDED BY THE AUTHOR “AS IS” AND
        ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
        PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
        DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
        DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
        OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
        HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
        STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
        ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        C# ProtoGen <br />
        ———– <br />
        Protocol Buffers – Google’s data interchange format Copyright 2008-2010
        Google Inc. All rights reserved.
        http://github.com/jskeet/dotnet-protobufs/ Original C++/Java/Python
        code: http://code.google.com/p/protobuf/ Redistribution and use in
        source and binary forms, with or without modification, are permitted
        provided that the following conditions are met: * Redistributions of
        source code must retain the above copyright notice, this list of
        conditions and the following disclaimer. * Redistributions in binary
        form must reproduce the above copyright notice, this list of conditions
        and the following disclaimer in the documentation and/or other materials
        provided with the distribution. * Neither the name of Google Inc. nor
        the names of its contributors may be used to endorse or promote products
        derived from this software without specific prior written permission.
        THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS
        IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED
        TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
        PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER
        OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
        PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
        LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        Microsoft Silverlight Windows Phone Toolkit <br />
        ——————————————- <br />
        Microsoft Public License (Ms-PL) This license governs use of the
        accompanying software. If you use the software, you accept this license.
        If you do not accept the license, do not use the software. 1.
        Definitions The terms “reproduce,” “reproduction,” “derivative works,”
        and “distribution” have the same meaning here as under U.S. copyright
        law. A “contribution” is the original software, or any additions or
        changes to the software. A “contributor” is any person that distributes
        its contribution under this license. “Licensed patents” are a
        contributor’s patent claims that read directly on its contribution. 2.
        Grant of Rights (A) Copyright Grant- Subject to the terms of this
        license, including the license conditions and limitations in section 3,
        each contributor grants you a non-exclusive, worldwide, royalty-free
        copyright license to reproduce its contribution, prepare derivative
        works of its contribution, and distribute its contribution or any
        derivative works that you create. (B) Patent Grant- Subject to the terms
        of this license, including the license conditions and limitations in
        section 3, each contributor grants you a non-exclusive, worldwide,
        royalty-free license under its licensed patents to make, have made, use,
        sell, offer for sale, import, and/or otherwise dispose of its
        contribution in the software or derivative works of the contribution in
        the software. 3. Conditions and Limitations (A) No Trademark License-
        This license does not grant you rights to use any contributors’ name,
        logo, or trademarks. (B) If you bring a patent claim against any
        contributor over patents that you claim are infringed by the software,
        your patent license from such contributor to the software ends
        automatically. (C) If you distribute any portion of the software, you
        must retain all copyright, patent, trademark, and attribution notices
        that are present in the software. (D) If you distribute any portion of
        the software in source code form, you may do so only under this license
        by including a complete copy of this license with your distribution. If
        you distribute any portion of the software in compiled or object code
        form, you may only do so under a license that complies with this
        license. (E) The software is licensed “as-is.” You bear the risk of
        using it. The contributors give no express warranties, guarantees or
        conditions. You may have additional consumer rights under your local
        laws which this license cannot change. To the extent permitted under
        your local laws, the contributors exclude the implied warranties of
        merchantability, fitness for a particular purpose and non-infringement.
      </Paragraph>
      <Paragraph>
        LLVM CLANG UTF Converter <br />
        ———————— <br />
        ConvertUTF.h ConvertUTF.c This file is distributed under the University
        of Illinois Open Source Permission is hereby granted, free of charge, to
        any person obtaining a copy of this software and associated
        documentation files (the “Software”), to deal with the Software without
        restriction, including without limitation the rights to use, copy,
        modify, merge, publish, distribute, sublicense, and/or sell copies of
        the Software, and to permit persons to whom the Software is furnished to
        do so, subject to the following conditions: * Redistributions of source
        code must retain the above copyright notice, this list of conditions and
        the following disclaimers. * Redistributions in binary form must
        reproduce the above copyright notice, this list of conditions and the
        following disclaimers in the documentation and/or other materials
        provided with the distribution. * Neither the names of the LLVM Team,
        University of Illinois at Urbana-Champaign, nor the names of its
        contributors may be used to endorse or promote products derived from
        this Software without specific prior written permission. THE SOFTWARE IS
        PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
        INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
        FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        CONTRIBUTORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
        OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
        ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
        OTHER DEALINGS WITH THE SOFTWARE. Copyright 2001-2004 Unicode, Inc.
        Disclaimer This source code is provided as is by Unicode, Inc. No claims
        are made as to fitness for any particular purpose. No warranties of any
        kind are expressed or implied. The recipient agrees to determine
        applicability of information provided. If this file has been purchased
        on magnetic or optical media from Unicode, Inc., the sole remedy for any
        claim will be exchange of defective media within 90 days of receipt.
        Limitations on Rights to Redistribute This Code Unicode, Inc. hereby
        grants the right to freely use the information supplied in this file in
        the creation of products supporting the Unicode Standard, and to make
        copies of this file in any form for internal or external distribution as
        long as this notice remains attached.
      </Paragraph>
      <Paragraph>
        Android PagerSlidingTabStrip <br />
        ——- <br />
        Copyright 2013 Andreas Stuetz Licensed under the Apache License, Version
        2.0 (the “License”); you may not use this file except in compliance with
        the License. You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable
        law or agreed to in writing, software distributed under the License is
        distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, either express or implied. See the License for the specific
        language governing permissions and limitations under the License.
        Android ViewPagerIndicator
      </Paragraph>
      <Paragraph>
        Android ViewPagerIndicator <br />
        —————- <br />
        Copyright 2012 Jake Wharton Copyright 2011 Patrik ï¿½kerfeldt Copyright
        2011 Francisco Figueiredo Jr. Licensed under the Apache License, Version
        2.0 (the “License”); you may not use this file except in compliance with
        the License. You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable
        law or agreed to in writing, software distributed under the License is
        distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, either express or implied. See the License for the specific
        language governing permissions and limitations under the License.
      </Paragraph>
      <Paragraph>
        android-support-v7-appcompat <br />
        —————- <br />
        Copyright (c) 2005-2008, The Android Open Source Project Licensed under
        the Apache License, Version 2.0 (the “License”); you may not use this
        file except in compliance with the License. Unless required by
        applicable law or agreed to in writing, software distributed under the
        License is distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for
        the specific language governing permissions and limitations under the
        License. Apache License Version 2.0, January 2004
        http://www.apache.org/licenses/
      </Paragraph>
      <Paragraph>
        android-switch-backport <br />
        —————- <br />
        From https://github.com/BoD/android-switch-backport Licensed under the
        Apache License, Version 2.0 (the “License”); you may not use this file
        except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0 Unless required by
        applicable law or agreed to in writing, software distributed under the
        License is distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for
        the specific language governing permissions and limitations under the
        License.
      </Paragraph>
      <Paragraph>
        Google Play Services <br />
        —————- <br />
        Copyright (c) 2005-2008, The Android Open Source Project Licensed under
        the Apache License, Version 2.0 (the “License”); you may not use this
        file except in compliance with the License. Unless required by
        applicable law or agreed to in writing, software distributed under the
        License is distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for
        the specific language governing permissions and limitations under the
        License. Apache License Version 2.0, January 2004
        http://www.apache.org/licenses/
      </Paragraph>
      <Paragraph>
        Lua <br />
        ———- <br />
        http://www.lua.org/license.html MIT License Copyright (c) 1994Â¿2013
        Lua.org, PUC-Rio. Permission is hereby granted, free of charge, to any
        person obtaining a copy of this software and associated documentation
        files (the “Software”), to deal in the Software without restriction,
        including without limitation the rights to use, copy, modify, merge,
        publish, distribute, sublicense, and/or sell copies of the Software, and
        to permit persons to whom the Software is furnished to do so, subject to
        the following conditions: The above copyright notice and this permission
        notice shall be included in all copies or substantial portions of the
        Software. THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY
        KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
        IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
        CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
        TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
        SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      </Paragraph>
      <Paragraph>
        libogg <br />
        —————- <br />
        From http://downloads.xiph.org/releases/ogg/libogg-1.3.0.tar.gz
        Copyright (c) 2002, Xiph.org Foundation Redistribution and use in source
        and binary forms, with or without modification, are permitted provided
        that the following conditions are met: – Redistributions of source code
        must retain the above copyright notice, this list of conditions and the
        following disclaimer. – Redistributions in binary form must reproduce
        the above copyright notice, this list of conditions and the following
        disclaimer in the documentation and/or other materials provided with the
        distribution. – Neither the name of the Xiph.org Foundation nor the
        names of its contributors may be used to endorse or promote products
        derived from this software without specific prior written permission.
        THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS
        IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED
        TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
        PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE FOUNDATION OR
        CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
        PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
        LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        libvorbis <br />
        ————- <br />
        From http://downloads.xiph.org/releases/vorbis/libvorbis-1.3.2.tar.gz
        Copyright (c) 2002, Xiph.org Foundation Redistribution and use in source
        and binary forms, with or without modification, are permitted provided
        that the following conditions are met: – Redistributions of source code
        must retain the above copyright notice, this list of conditions and the
        following disclaimer. – Redistributions in binary form must reproduce
        the above copyright notice, this list of conditions and the following
        disclaimer in the documentation and/or other materials provided with the
        distribution. – Neither the name of the Xiph.org Foundation nor the
        names of its contributors may be used to endorse or promote products
        derived from this software without specific prior written permission.
        THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS
        IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED
        TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
        PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE FOUNDATION OR
        CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
        PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
        LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        sqlite <br />
        ———- <br />
        From: http://www.sqlite.org/sqlite-autoconf-3071100.tar.gz Public domain
        License: http://www.sqlite.org/copyright.html
      </Paragraph>
      <Paragraph>
        uriparser <br />
        ———- <br />
        From:
        http://downloads.sourceforge.net/project/uriparser/Sources/0.7.7/uriparser-0.7.7.tar.bz2
        Copyright (C) 2007, Weijia Song &lt;songweijia@gmail.com&gt; Copyright
        (C) 2007, Sebastian Pipping &lt;webmaster@hartwork.org&gt; All rights
        reserved. Redistribution and use in source and binary forms, with or
        without modification, are permitted provided that the following
        conditions are met: * Redistributions of source code must retain the
        above copyright notice, this list of conditions and the following
        disclaimer. * Redistributions in binary form must reproduce the above
        copyright notice, this list of conditions and the following disclaimer
        in the documentation and/or other materials provided with the
        distribution. * Neither the name of the nor the names of its
        contributors may be used to endorse or promote products derived from
        this software without specific prior written permission. THIS SOFTWARE
        IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY
        EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
        PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR
        CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
        PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
        LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
        NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
        SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      </Paragraph>
      <Paragraph>
        moai <br />
        ——— <br />
        http://getmoai.com/moai-faqs.html Common Public Attribution License
        Version 1.0 (CPAL-1.0) Can be found @
        http://opensource.org/licenses/cpal_1.0
      </Paragraph>
      <Paragraph>
        flurry <br />
        ——— <br />
        http://www.flurry.com/tos.html
      </Paragraph>
      <Paragraph>
        aviary <br />
        ———- <br />
        Custom licensing deal between Tango & Aviary. Check legal department.
      </Paragraph>
      <Paragraph>
        vsoft <br />
        ——– <br />
        Custom licensing deal between Tango & vSoft. Check legal department.
      </Paragraph>
      <Paragraph>
        pjsip <br />
        —— <br />
        Custom licensing deal between Tango & pjsip. Check legal department.
      </Paragraph>
      <Paragraph>
        apache_mime4j_core <br />
        ———- <br />
        http://opensource.org/licenses/Apache-2.0
      </Paragraph>
      <Paragraph>
        android_support_v4 <br />
        ———- <br />
        http://opensource.org/licenses/Apache-2.0
      </Paragraph>
      <Paragraph>
        ACRA <br />
        ——— <br />
        https://github.com/ACRA/acra/blob/master/LICENSE Apache 2.0 license:
        http://opensource.org/licenses/Apache-2.0
      </Paragraph>
      <Paragraph>
        jsoncpp <br />
        ——- <br />
        From: http://jsoncpp.sourceforge.net/LICENSE Copyright (c) 2007-2010
        Baptiste Lepilleur Permission is hereby granted, free of charge, to any
        person obtaining a copy of this software and associated documentation
        files (the “Software”), to deal in the Software without restriction,
        including without limitation the rights to use, copy, modify, merge,
        publish, distribute, sublicense, and/or sell copies of the Software, and
        to permit persons to whom the Software is furnished to do so, subject to
        the following conditions: The above copyright notice and this permission
        notice shall be included in all copies or substantial portions of the
        Software. THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY
        KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
        IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
        CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
        TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
        SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      </Paragraph>
      <Paragraph>
        curl <br />
        —- <br />
        From: http://curl.haxx.se/docs/copyright.html COPYRIGHT AND PERMISSION
        NOTICE Copyright (c) 1996 – 2013, Daniel Stenberg,
        &lt;daniel@haxx.se&gt;. All rights reserved. Permission to use, copy,
        modify, and distribute this software for any purpose with or without fee
        is hereby granted, provided that the above copyright notice and this
        permission notice appear in all copies. THE SOFTWARE IS PROVIDED “AS
        IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
        LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE AND NONINFRINGEMENT OF THIRD PARTY RIGHTS. IN NO EVENT SHALL THE
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
        DEALINGS IN THE SOFTWARE. Except as contained in this notice, the name
        of a copyright holder shall not be used in advertising or otherwise to
        promote the sale, use or other dealings in this Software without prior
        written authorization of the copyright holder.
      </Paragraph>
      <Paragraph>
        boost <br />
        —– <br />
        From: http://www.boost.org/users/license.html Boost Software License –
        Version 1.0 – August 17th, 2003 Permission is hereby granted, free of
        charge, to any person or organization obtaining a copy of the software
        and accompanying documentation covered by this license (the “Software”)
        to use, reproduce, display, distribute, execute, and transmit the
        Software, and to prepare derivative works of the Software, and to permit
        third-parties to whom the Software is furnished to do so, all subject to
        the following: The copyright notices in the Software and this entire
        statement, including the above license grant, this restriction and the
        following disclaimer, must be included in all copies of the Software, in
        whole or in part, and all derivative works of the Software, unless such
        copies or derivative works are solely in the form of machine-executable
        object code generated by a source language processor. THE SOFTWARE IS
        PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
        INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
        FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT. IN NO EVENT SHALL
        THE COPYRIGHT HOLDERS OR ANYONE DISTRIBUTING THE SOFTWARE BE LIABLE FOR
        ANY DAMAGES OR OTHER LIABILITY, WHETHER IN CONTRACT, TORT OR OTHERWISE,
        ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
        OTHER DEALINGS IN THE SOFTWARE.
      </Paragraph>
      <Paragraph>
        StaggeredGridView <br />
        —————- <br />
        From https://github.com/etsy/AndroidStaggeredGrid Copyright (c) 2013
        Etsy Licensed under the Apache License, Version 2.0 (the “License”); you
        may not use this file except in compliance with the License. You may
        obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable
        law or agreed to in writing, software distributed under the License is
        distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, either express or implied. See the License for the specific
        language governing permissions and limitations under the License.
      </Paragraph>
      <Paragraph>
        rapidjson <br />
        ——— <br />
        From:
        https://code.google.com/p/rapidjson/downloads/detail?name=rapidjson-0.11.zip
        Copyright (C) 2011 Milo Yip Permission is hereby granted, free of
        charge, to any person obtaining a copy of this software and associated
        documentation files (the “Software”), to deal in the Software without
        restriction, including without limitation the rights to use, copy,
        modify, merge, publish, distribute, sublicense, and/or sell copies of
        the Software, and to permit persons to whom the Software is furnished to
        do so, subject to the following conditions: The above copyright notice
        and this permission notice shall be included in all copies or
        substantial portions of the Software. THE SOFTWARE IS PROVIDED “AS IS”,
        WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
        LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
        HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN
        AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
        CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
        SOFTWARE.
      </Paragraph>
      <Paragraph>
        DragSortListView <br />
        —————- <br />
        From https://github.com/bauerca/drag-sort-listview A subclass of the
        Android ListView component that enables drag and drop re-ordering of
        list items. Copyright 2012 Carl Bauer Licensed under the Apache License,
        Version 2.0 (the “License”); you may not use this file except in
        compliance with the License. You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable
        law or agreed to in writing, software distributed under the License is
        distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, either express or implied. See the License for the specific
        language governing permissions and limitations under the License.
      </Paragraph>
      <Paragraph>
        CWAC MergeAdapter <br />
        —————- <br />
        From https://github.com/commonsguy/cwac-merge Licensed under the Apache
        License, Version 2.0 (the “License”); you may not use this file except
        in compliance with the License. You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable
        law or agreed to in writing, software distributed under the License is
        distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, either express or implied. See the License for the specific
        language governing permissions and limitations under the License.
      </Paragraph>
      <Paragraph>
        CWAC SackOfViewsAdapter <br />
        —————- <br />
        From https://github.com/commonsguy/cwac-sacklist Licensed under the
        Apache License, Version 2.0 (the “License”); you may not use this file
        except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0 Unless required by
        applicable law or agreed to in writing, software distributed under the
        License is distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for
        the specific language governing permissions and limitations under the
        License.
      </Paragraph>
      <Paragraph>
        FlowLayout <br />
        ————– <br />
        From https://github.com/ApmeM/android-flowlayout Copyright 2011, Artem
        Votincev (apmem.org) Licensed under the Apache License, Version 2.0 (the
        “License”); you may not use this file except in compliance with the
        License. You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable
        law or agreed to in writing, software distributed under the License is
        distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, either express or implied. See the License for the specific
        language governing permissions and limitations under the License.
        PayPal’s card.io, MIT license: Copyright (c) 2013-2014 eBay Software
        Foundation Permission is hereby granted, free of charge, to any person
        obtaining a copy of this software and associated documentation files
        (the “Software”), to deal in the Software without restriction, including
        without limitation the rights to use, copy, modify, merge, publish,
        distribute, sublicense, and/or sell copies of the Software, and to
        permit persons to whom the Software is furnished to do so, subject to
        the following conditions: The above copyright notice and this permission
        notice shall be included in all copies or substantial portions of the
        Software. THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY
        KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
        IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
        CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
        TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
        SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. AgileBits’
        1Password App Extension, MIT license: Copyright (c) 2014 AgileBits Inc.
        Permission is hereby granted, free of charge, to any person obtaining a
        copy of this software and associated documentation files (the
        “Software”), to deal in the Software without restriction, including
        without limitation the rights to use, copy, modify, merge, publish,
        distribute, sublicense, and/or sell copies of the Software, and to
        permit persons to whom the Software is furnished to do so, subject to
        the following conditions: The above copyright notice and this permission
        notice shall be included in all copies or substantial portions of the
        Software. THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY
        KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
        IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
        CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
        TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
        SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. Eigen: MPLv2
        license text can be found at http://www.mozilla.org/MPL/2.0/; the source
        code is available at https://bitbucket.org/eigen/eigen/ or via
        http://eigen.tuxfamily.org/ Erica Sadun’s code, BSD license: Copyright
        (c) 2012, Erica Sadun All rights reserved. Redistribution and use in
        source and binary forms, with or without modification, are permitted
        provided that the following conditions are met: Redistributions of
        source code must retain the above copyright notice, this list of
        conditions and the following disclaimer. Redistributions in binary form
        must reproduce the above copyright notice, this list of conditions and
        the following disclaimer in the documentation and/or other materials
        provided with the distribution. THIS SOFTWARE IS PROVIDED BY THE
        COPYRIGHT HOLDERS AND CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED
        WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
        MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
        NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY
        DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
        DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
        OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
        HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
        STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
        ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGE. George Kitz’s
        UIDevice-with-UniqueIdentifier-for-iOS-5, MIT license: Copyright (C)
        2012, Georg Kitz, @gekitz Permission is hereby granted, free of charge,
        to any person obtaining a copy of this software and associated
        documentation files (the “Software”), to deal in the Software without
        restriction, including without limitation the rights to use, copy,
        modify, merge, publish, distribute, sublicense, and/or sell copies of
        the Software, and to permit persons to whom the Software is furnished to
        do so, subject to the following conditions: The above copyright notice
        and this permission notice shall be included in all copies or
        substantial portions of the Software. THE SOFTWARE IS PROVIDED “AS IS”,
        WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
        LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
        HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN
        AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
        CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
        SOFTWARE. Colloquy’s Chat Core, BSD license: Actual license text not
        provided — [the Colloquy
        website](http://colloquy.info/project/wiki/Source%20Code) says “Chat
        Core is licensed under the BSD license terms”. For generic BSD license
        text, see http://opensource.org/licenses/bsd-license.php Willow Garage’s
        OpenCV, BSD license: Actual license text not provided — [the OpenCV
        website](http://opencv.willowgarage.com/wiki/) says “OpenCV is released
        under a BSD license, it is free for both academic and commercial use.”,
        with links to http://opensource.org/licenses/bsd-license.php and
        http://en.wikipedia.org/wiki/BSD_licenses Josh Bleecher Snyder’s
        TLCommon, MIT license: The MIT License Copyright (c) 2009 Permission is
        hereby granted, free of charge, to any person obtaining a copy of this
        software and associated documentation files (the “Software”), to deal in
        the Software without restriction, including without limitation the
        rights to use, copy, modify, merge, publish, distribute, sublicense,
        and/or sell copies of the Software, and to permit persons to whom the
        Software is furnished to do so, subject to the following conditions: The
        above copyright notice and this permission notice shall be included in
        all copies or substantial portions of the Software. THE SOFTWARE IS
        PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
        INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
        FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
        DEALINGS IN THE SOFTWARE. Tomáš Znamenáček’s Lambda Alert, MIT license:
        Copyright (c) 2010–2011 Tomáš Znamenáček, Permission is hereby granted,
        free of charge, to any person obtaining a copy of this software and
        associated documentation files (the “Software”), to deal in the Software
        without restriction, including without limitation the rights to use,
        copy, modify, merge, publish, distribute, sublicense, and/or sell copies
        of the Software, and to permit persons to whom the Software is furnished
        to do so, subject to the following conditions: The above copyright
        notice and this permission notice shall be included in all copies or
        substantial portions of the Software. The software is provided “as is”,
        without warranty of any kind, express or implied, including but not
        limited to the warranties of merchantability, fitness for a particular
        purpose and noninfringement. In no event shall the authors or copyright
        holders be liable for any claim, damages or other liability, whether in
        an action of contract, tort or otherwise, arising from, out of or in
        connection with the Software or the use or other dealings in the
        Software. Facebook’s Three20, Apache 2.0 license: Copyright 2009-2011
        Facebook Licensed under the Apache License, Version 2.0 (the “License”);
        you may not use this file except in compliance with the License. You may
        obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable
        law or agreed to in writing, software distributed under the License is
        distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, either express or implied. See the License for the specific
        language governing permissions and limitations under the License.
        Openstack, Apache 2.0 license: Actual license text not provided — [the
        Openstack website](http://openstack.org/) says “The OpenStack project is
        provided under the Apache 2.0 license.”; the Apache 2.0 license text can
        be found at http://www.apache.org/licenses/LICENSE-2.0.txt Makoto
        Matsumoto and Takuji Nishimura’s Mersenne Twister Copyright (C) 1997 –
        2002, Makoto Matsumoto and Takuji Nishimura, All rights reserved.
        Redistribution and use in source and binary forms, with or without
        modification, are permitted provided that the following conditions are
        met: 1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer. 2.
        Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution. 3.
        The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
        CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
        BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
        FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
        COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
        INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
        NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
        USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
        ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
        (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
        THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. Makoto
        Matsumoto and Takuji Nishimura’s Mersenne Twister Copyright (C) 1997 –
        2002, Makoto Matsumoto and Takuji Nishimura, All rights reserved.
        Redistribution and use in source and binary forms, with or without
        modification, are permitted provided that the following conditions are
        met: 1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer. 2.
        Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution. 3.
        The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
        CONTRIBUTORS “AS IS” AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING,
        BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
        FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
        COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
        INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
        NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
        USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
        ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
        (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
        THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. Square
        OkHttp, Apache 2.0 license: Copyright 2014 Square, Inc. Licensed under
        the Apache License, Version 2.0 (the “License”); you may not use this
        file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0 Unless required by
        applicable law or agreed to in writing, software distributed under the
        License is distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR
        CONDITIONS OF ANY KIND, either express or implied. See the License for
        the specific language governing permissions and limitations under the
        License. Apache Commons Lang, Apache 2.0 license: Licensed to the Apache
        Software Foundation (ASF) under one or more contributor license
        agreements. See the NOTICE file distributed with this work for
        additional information regarding copyright ownership. The ASF licenses
        this file to You under the Apache License, Version 2.0 (the “License”);
        you may not use this file except in compliance with the License.  You
        may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable
        law or agreed to in writing, software distributed under the License is
        distributed on an “AS IS” BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, either express or implied. See the License for the specific
        language governing permissions and limitations under the License.
      </Paragraph>
    </article>
  </>
);

export default ThirdPartyLicense;
